import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=07deb51a&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=07deb51a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07deb51a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07deb51a')) {
      api.createRecord('07deb51a', component.options)
    } else {
      api.reload('07deb51a', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=07deb51a&scoped=true", function () {
      api.rerender('07deb51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Statistics.vue"
export default component.exports